/* eslint-disable eqeqeq */
import React from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import { useLocation, useNavigate } from "react-router";

import {
  getPlayerState,
  setPlaying,
} from "../../../../redux/features/playerSlice";
import CustomAvatar from "../../CustomAvatar";
import RightLeftChecker from "./../../../../utils/RightLeftChecker";
import CustomCircleButton from "../../CustomCircleButton";

const PlayList = ({ rowData }) => {
  const { playing } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");

  const handleNavigateTopic = (id) => {
    if (urlParams[6] != id) {
      navigate(
        `/table/${urlParams[2]}/${urlParams[3]}/${urlParams[4]}/topics/${id}`,
        { replace: true }
      );
      dispatch(setPlaying(true));
    } else {
      dispatch(setPlaying(!playing));
    }
  };

  return (
    <Box
      onClick={() => handleNavigateTopic(rowData.pk)}
      sx={{
        border: "2px solid",
        borderColor: "black.main",
        borderRadius: "16px",
        minHeight: "80px",
        display: "flex",
        alignItems: "center",
        padding: "16px",
        justifyContent: "space-between",
        marginBottom: "16px",
        overflow: "hidden",
        cursor: "pointer",
        backgroundColor:
          urlParams[6] == rowData.pk ? "black.main" : "white.main",
      }}
    >
      <Box
        sx={{
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Box sx={{ mr: "8px" }}>
          <CustomAvatar
            src={rowData.thumbnail ? rowData.thumbnail : rowData.author.avatar}
            size={48}
            iconType={"video"}
            iconSize={22}
            round={"8px"}
            alt={rowData.author.nickname}
            borderColor={
              urlParams[6] == rowData.pk ? "white.main" : "black.main"
            }
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Typography
              noWrap
              sx={{
                fontFamily: "Tahrir",
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "24px",
                maxWidth: "260px",
                pb: "2px",
                color: urlParams[6] == rowData.pk ? "white.main" : "black.main",
                direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
              }}
            >
              {rowData.title}
            </Typography>

            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "16px",
                color: urlParams[6] == rowData.pk ? "white.main" : "mute.main",
                maxWidth: "210px",
                mt: "3px",
              }}
            >
              {rowData.author.username}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <CustomCircleButton
          width='40px'
          height='40px'
          bgColor={urlParams[6] == rowData.pk ? "primary.main" : "white.main"}
          color='black.main'
          bShadow='none'
          border='2px solid'
          hoverBgColor='white.main'
          hoverColor='black.main'
          hoverBorder={`2px solid`}
          activeBgColor='black.main'
          activeColor='white.main'
        >
          {playing && urlParams[6] == rowData.pk ? (
            <PauseRoundedIcon sx={{ fontSize: "24px" }} />
          ) : (
            <PlayArrowRoundedIcon sx={{ fontSize: "26px" }} />
          )}
        </CustomCircleButton>
      </Box>
    </Box>
  );
};

export default PlayList;
